import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'
import { useIsDesktop } from '~/@mid_ui/layout/useIsDesktop'
import { SecuritySettings } from './SecuritySettings'

function SecurityPage() {
  const isDesktop = useIsDesktop()
  return (
    <PageContainer className="flex flex-col gap-10 w-full pt-10 pb-15 md:pl-40 md:pr-15">
      {isDesktop && <HeadingThree>Nastavenie bezpečnosti</HeadingThree>}
      <SecuritySettings />
    </PageContainer>
  )
}

export default SecurityPage
